
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512.008 512.008"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M502.795 60.572c-11.183-9.782-28.214-8.677-38.023 2.533L177.837 391.028 46.603 251.036c-10.186-10.833-27.217-11.372-38.077-1.213-10.86 10.159-11.426 27.244-1.24 38.104l151.579 161.684a27.033 27.033 0 0019.672 8.488h.458c7.626-.108 14.794-3.449 19.833-9.189L505.355 98.595c9.782-11.21 8.65-28.214-2.56-38.023z","fill":"#6cdf5a","data-original":"#000000"}})])
          )
        }
      }
    